<mat-expansion-panel class="panel-container">
  <mat-expansion-panel-header class="panel-container-inner">
    <mat-panel-title class="panel-main-title" i18n>
      ID Verification
    </mat-panel-title>
    @if (idvStatus === 'NONE' || idvStatus === 'RETRY' ) {
      <mat-panel-description i18n>
        Click to begin ID verification, if required.
      </mat-panel-description>
    } @else {
      <mat-panel-description i18n>
        Click to view your verification status.
      </mat-panel-description>
    }
  </mat-expansion-panel-header>
  @if (idvStatus === 'NONE' || idvStatus === 'RETRY' ) {
    <button class="button-container" i18n (click)="gotoIdentity()">
      <mat-icon class="button-icon button-icon-black" class="left-icon">photo_camera</mat-icon>
      <span class="button-text" >Identity <br /></span>
      <span class="button-text">Click to upload an ID and a selfie.</span>
      <mat-icon class="button-icon">launch</mat-icon>
    </button>
  }
  @else {
    <button class="button-container button-unclickable" i18n role="listitem">
      @switch (idvStatus ) {
        @case ("PENDING") {
          <mat-icon style="color: orange;">av_timer</mat-icon>
        }
        @case ("SUCCESS") {
          <mat-icon style="color: green;">verified_user</mat-icon>
        }        
        @case ("FAILED") {
          <mat-icon style="color: #AD0000;">report</mat-icon>
        }
        @default {
          <mat-icon style="color: #AD0000;">stars</mat-icon>
        }
      }
      <span class="button-text">
        {{statusText}}
      </span>     
    </button>
  }

@if (displaySpinner) {
  <div class="progressSpinner">
    <mat-spinner [diameter]="300" color="primary"></mat-spinner>
    <div class="spinner-warning">
      <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
    </div>
  </div>
}
  